import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import './index.css'
import VueYoutube from 'vue-youtube'
import firebase from 'firebase'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const config = {
  apiKey: "AIzaSyDsktuGnckoxqmBMqt8FPvT59TbKW4UBMw",
  authDomain: "dancenotes.firebaseapp.com",
  projectId: "dancenotes",
  storageBucket: "dancenotes.appspot.com",
  messagingSenderId: "623214681351",
  appId: "1:623214681351:web:21c059766073a85e0fb9a2",
  measurementId: "G-1Z8FXM563Q"
};

const firebaseApp = firebase.initializeApp(config)
export const analytics = firebase.analytics()
export const db = firebaseApp.database();
export const storage = firebaseApp.storage();

import router from './router'

export const bus = new Vue();

Vue.use(VueYoutube)
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: null,
    isAdmin: null,
    classes: null,
    classesArray: null,
    currentClassKey: null,
    currentClass: "No class selected",
    lessons: null,
    lessonsArray: null,
    currentLessonIndex: 0,
    currentLessonKey: null,
    currentLesson: null,
    annotations: null,
    annotationsArray: null,
    instructors: null,
    currentVideoYT: "",
    duration: 0,
    playerCurrentTime: 0,
    playerState: "paused",
    playerIsMuted: false,
    currentFigureIndex: 0,
    currentRole: "Lead",
  },
  mutations: {
    setUser(state, obj) {
      state.user = obj;
    },
    setAuthState(state, bool) {
      state.isLoggedIn = bool
    },
    setIsAdmin(state, bool) {
      state.isAdmin = bool
    },
    setClasses(state, obj) {
      state.classes = obj
    },
    setClassesArray(state, array) {
      state.classesArray = array
    },
    setClass(state, newClass) {
      state.currentClass = newClass
    },
    setClassKey(state, newClassKey) {
      state.currentClassKey = newClassKey
    },
    setLessonIndex(state, index) {
      state.currentLessonIndex = index
    },
    setLessonKey(state, key) {
      state.currentLessonKey = key
    },
    setLessons(state, lesson) {
      state.lessons = lesson
    },
    setLessonsArray(state, newLessonList) {
      state.lessonsArray = newLessonList
    },
    setLesson(state, lesson) {
      state.currentLesson = lesson
    },
    setAnnotations(state, annotation) {
      state.annotations = annotation
    },
    setAnnotationsArray(state, annotationArray) {
      state.annotationsArray = annotationArray
    },
    setInstructors(state, obj) {
      state.instructors = obj
    },
    setDuration(state, newDuration) {
      state.duration = newDuration
    },
    setVideo(state, newYTID) {
      state.currentVideoYT = newYTID
    },
    changeState(state, newState) {
      state.playerState = newState
    },
    changeRole(state, newRole) {
      state.currentRole = newRole
    },
    unMute(state) {
      state.playerIsMuted = false
    },
    setPlayerCurrentTime(state, newTime) {
      state.playerCurrentTime = newTime
    },
    mute(state) {
      state.playerIsMuted = true
    },
    nextFigure(state) {
      state.currentFigureIndex += 1
    },
    prevFigure(state) {
      state.currentFigureIndex -= 1
    },
    setFigure(state, idx) {
      state.currentFigureIndex = idx
    }
  },
  actions: {
    setClasses(context) {
      return new Promise((resolve) => {
        var list = []
        db.ref("classes").orderByChild('index')
          .once('value')
          .then((snapshot) => {
            if (snapshot.exists()) {
              snapshot.forEach((item) => {
                list.push(item.val())
              })
              context.commit("setClasses", snapshot.val());
              context.commit("setClassesArray", list);
              resolve()
            } else {
              console.log("Could not get classes.");
            }
          })
          .catch((error) => {
            console.error(error);
          });
      })
    },
    setClassByKey(context, key) {
      return new Promise((resolve) => {
        context.commit('setClassKey', key)
        db.ref(`classes/${key}`)
          .once('value')
          .then((snapshot) => {
            if (snapshot.exists()) {
              context.commit('setClass', snapshot.val())
              resolve()
            } else {
              console.log(`Could not get class: ${key}`);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      })
    },
    setLessonsByClassKey(context, classKey) {
      return new Promise((resolve) => {
        db.ref(`lessons/${classKey}`).orderByChild('index')
          .once('value')
          .then((snapshot) => {
            if (snapshot.exists()) {
              var lessonList = [];
              snapshot.forEach((item) => {
                var lesson = item.val()
                lesson['key'] = item.key
                lessonList.push(lesson)
              })
              context.commit('setLessons', snapshot.val())
              context.commit('setLessonsArray', lessonList)
              resolve()

            } else {
              context.commit('setLessons', null)
              context.commit('setLessonsArray', null)
              console.log(`Could not get lessons for: ${classKey}`);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      })

    },
    setLessonByIndex(context, idx) {
      context.commit("setLessonIndex", idx)
      context.commit("setLessonKey", context.state.lessonsArray[idx].key)
      context.commit("setLesson", context.state.lessons[context.state.currentLessonKey])

    },
    setLessonByKey(context, lessonKey) {
      context.commit("setLessonKey", lessonKey)
      context.commit("setLesson", context.state.lessons[lessonKey])
      context.commit("setLessonIndex", context.state.lessons[lessonKey].index)

    },
    setAnnotationsCurrentKeys(context) {
      db.ref(`annotations/${context.state.currentClassKey}/${context.state.currentLessonKey}`)
        .orderByChild('startTime').once('value')
        .then((snapshot) => {
          if (snapshot.exists()) {
            var annotationList = [];
            snapshot.forEach((item) => {
              var annotation = item.val()
              annotation['key'] = item.key
              annotationList.push(annotation)
            })
            context.commit("setAnnotations", snapshot.val())
            context.commit("setAnnotationsArray", annotationList)
          } else {
            context.commit("setAnnotations", null)
            context.commit("setAnnotationsArray", [])

          }
        })
        .catch((error) => {
          console.error(error);
        });

    },
    setInstructors(context) {
      return new Promise((resolve) => {

        db.ref(`instructors`)
          .once('value')
          .then((snapshot) => {
            if (snapshot.exists()) {
              context.commit("setInstructors", snapshot.val())
              resolve()
            } else {
              context.commit("setInstructors", null)
            }
          })
          .catch((error) => {
            console.error(error);
          });
      })
    }

  },

})
let app;

firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      store,
      router,
      render: h => h(App)
    }).$mount('#app')
  }
})
